import Form from "@/components/Forms/Form"
import { useMemo, useState } from "react"
import { useForm } from "@formspree/react"
import { extractExtraFormValues, getGlobalFormSpreeEvnKey, getInitialFormValues } from "@/components/Forms/utils"
import styled from "styled-components"
import { getCssSizeValue, getPaddingsClassFromData } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import GridContainer from "@/components/common/GridContainer"
import SubmissionModal from "@/components/Forms/SubmissionModal"
import useGlobals from "@/hooks/useGlobals"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const StyledWrapper = styled(GridContainer)``

const StyledInputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	row-gap: ${getCssSizeValue(48, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		row-gap: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
	}
`

export default function SignupFormModule({ data }) {
	const { signupModalCancelButtonText, signupModalSuccessData, signupModalErrorData } = useGlobals()
	const paddings = getPaddingsClassFromData(data)
	const formAPIKey = getGlobalFormSpreeEvnKey()
	const submitButtonText = data?.submitButtonText || ""
	const inputs = data?.inputs || []
	const [modalOpen, setModalOpen] = useState(false)

	const initialFormData = useMemo(() => {
		return getInitialFormValues(inputs)
	})

	const [formData, setFormData] = useState(initialFormData)

	const [state, formSubmit] = useForm(formAPIKey, {
		data: extractExtraFormValues(formData),
	})

	const handleSubmit = (e) => {
		e.preventDefault()
		formSubmit(e)
		setModalOpen(true)
		setFormData(initialFormData)
	}

	const modalData = useMemo(() => {
		const { succeeded } = state

		let result = {
			closeButtonText: signupModalCancelButtonText || "",
		}

		if (succeeded) {
			result = {
				...result,
				header: signupModalSuccessData?.header || "",
				icon: signupModalSuccessData?.icon || {},
			}
		} else {
			result = {
				...result,
				header: signupModalErrorData?.header || "",
				icon: signupModalErrorData?.icon || {},
			}
		}

		return result
	}, [state.succeeded])

	return (
		<div className={paddings}>
			<HeaderDescriptionBlock headerDescription={data?.headerDescription} />
			<StyledWrapper>
				<SubmissionModal modalOpen={modalOpen} setModalOpen={setModalOpen} modalData={modalData} loading={state.submitting} />

				<div className="col-desktop-4 col-tablet-8 col-mobile-8 typo-borna">
					<Form
						formData={formData}
						setFormData={setFormData}
						handleSubmit={handleSubmit}
						inputs={inputs}
						submitButtonText={submitButtonText}
						LayoutWrapper={StyledInputsWrapper}
					/>
				</div>
			</StyledWrapper>
		</div>
	)
}
